import { render, staticRenderFns } from "./CapituloDosPage.vue?vue&type=template&id=b13cc038"
import script from "./CapituloDosPage.js?vue&type=script&lang=js&external"
export * from "./CapituloDosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports